import { useEffect, useMemo, useState } from "react";
import { Cookies } from "react-cookie";
import useAuthenticationContext from "../services/context/authentication/use-authentication-context.ts";

const useAuthCheck = () => {
    // Gestion de la partie authentification de l'utilisateur.
    // On vérifie la mémoire. Si la mémoire est vide, on tente de se connecter avec l'information de cookie.
    const { authenticationResponse, refetchCookieSession } =  useAuthenticationContext();
    const cookies = useMemo(() => new Cookies(), []);

    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(authenticationResponse != null);
    const [isFetchingAuthenticationInformations, setIsFetchingAuthenticationInformations] = useState<boolean>(!isAuthenticated);

    useEffect(() => {
        if (isAuthenticated)
            return;

        const shouldRefetch = cookies.get(`${import.meta.env.VITE_COOKIE_NAME}`);

        if (shouldRefetch) {
            refetchCookieSession()
                .then((refetchResult) => {
                    setIsAuthenticated(refetchResult);
                })
                .finally(() => {
                    setIsFetchingAuthenticationInformations(false);
                });
        } else {
            setIsFetchingAuthenticationInformations(false);
        }
    }, [isAuthenticated, cookies, refetchCookieSession]);

    return { isAuthenticated, isFetchingAuthenticationInformations };
};

export default useAuthCheck;